"use client";
export const SkipToMain = () => {
  return (
    <a
      className="button secondary absolute z-50 -top-[100px] left-4 focus:top-4"
      onClick={(e) => {
        e.preventDefault();
        document.getElementById("main")?.focus();
      }}
      href="#"
    >
      Skip to main content
    </a>
  );
};
